import React from 'react'
import { RxAvatar } from "react-icons/rx";
import { FaUpload } from "react-icons/fa";
import { IconButton, TextField } from '@mui/material';
import { FileUploadOutlined } from '@mui/icons-material';
import { getCookie } from '../../../function';
import getChatService from '../../../services/getChatService';

const Chats = () => {
    const [input, setInput] = React.useState({
        description: '',
        chatFile: null,
        userId: getCookie('id')
    })
    const { description, chatFile, userId } = input

    const handleUpload = (e) => {
        setInput({
            ...input,
            chatFile: e.target.files[0]
        })
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (description || chatFile) {
            let formData = new FormData();
            formData.append('clientId', userId);
            formData.append('description', description);
            formData.append('chatFile', chatFile);
            try {
                let respons = await getChatService.CreateChat(formData);
                
                if (respons.status === 200) {
                    setInput({
                        ...input,
                        chatFile: null,
                        description: ''
                    })
                }
            } catch (error) {
                console.error('Error editing category:', error);
            }
        }
    }
    return (

        <>
            <h4 className='p-3 pageHead' >Upload Screenshot</h4>
            <div className='d-flex justify-content-around align-middle paymentchat' >
                <div className='w-50' >
                    <form onSubmit={handleSubmit}>
                        <div className='d-flex' >
                            <button className='avatar' >
                                <RxAvatar />
                            </button>
                            <span>
                                {/* <p>Govind</p> */}
                                <TextField
                                    variant="outlined"
                                    type="text"
                                    // className='mt-3'
                                    value={chatFile?.name || ''}
                                    disabled
                                    size='small'
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton component="label">
                                                <FileUploadOutlined />
                                                <input
                                                    styles={{ display: "none" }}
                                                    type="file"
                                                    hidden
                                                    accept="image/jpeg,image/png,image/gif"
                                                    onChange={handleUpload}
                                                    name="[licenseFile]"
                                                />
                                            </IconButton>
                                        ),
                                    }}
                                />
                                {/* <button className='upload' ><FaUpload />    Upload Screenshot</button> */}
                            </span>
                        </div>
                        <div className='mt-3' >
                            <textarea placeholder='Your Message' value={description} onChange={(e) => setInput({ ...input, description: e.target.value })} ></textarea>
                            <button className='upload' type='submit' >Send</button>
                        </div>
                    </form>
                </div>
            </div>
        </>

    )
}

export default Chats